module.exports = __webpack_public_path__ + "img/assumpta.086d1269.png";